const ENModalIndicatorsPermissions = {
	"Permissões de indicadores": "Indicators permissions",
	"Permissões de Indicadores": "Indicators Permissions",
	"Permissões salvas com sucesso": "Permissions successfully saved",
	"Permissão salva com sucesso": "Permission successfully saved",
	"É necessário especificar os indicadores": "It is necessary to specify the indicators",
	"Erro ao salvar as permissões": "Error saving permissions",
	"Erro ao excluir permissões": "Error deleting permissions",
	"Permissões excluídas com sucesso": "Permissions successfully deleted"
};

export default ENModalIndicatorsPermissions;
